import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import {BootstrapVue, IconsPlugin} from "bootstrap-vue"
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"

import * as VueGoogleMaps from 'vue2-google-maps'
import axios from "axios"
import moment from 'moment'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2, {
  position: "top-end",
  showConfirmButton: false,
  timer: 2000,
  toast: true,
});

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBP1YuOeIr9DdXXdVs-hYAsDe3Q3YmCHQE',
    libraries: 'places',
  },
  installComponents: true
})

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)

Vue.prototype.$vapid_key = "BAsYML9W-mSPa9CvhClCxWk-4thHW1m20_G38k0ocigP4ujqsbKKonveuOfCwnDgeEl-k5nx-LZqDw_y2Dq1YIA";

import messaging from '@/firebase/messaging.js'
import { getToken } from "firebase/messaging";

if(!localStorage.getItem('sigofood_fcm')) {
    getToken(messaging, {vapidKey: "BAsYML9W-mSPa9CvhClCxWk-4thHW1m20_G38k0ocigP4ujqsbKKonveuOfCwnDgeEl-k5nx-LZqDw_y2Dq1YIA"}).then((fcm) => {
      if(fcm) {
        //this.fcm = fcm;
        localStorage.setItem('sigofood_fcm', fcm); 
        console.log(fcm);
      }
    });
}

// import auth from '@/firebase/anonymous-signin.js'
// import { signInAnonymously } from "firebase/auth";
// if(!localStorage.getItem('sigofood_uid')) {
//   signInAnonymously(auth)
//   .then((response) => {
//       if(response.user) {
//         localStorage.setItem('sigofood_uid', response.user.uid); 
//         console.log(response.user.uid);
//       }
//   })
//   .catch((error) => {
//       console.log(error);
//   });

// }

Vue.prototype.$axios = axios.create({
  baseURL: 'https://ourworks.co.in/sigofood/flutter/',
  //baseURL: 'http://localhost/sigofood/flutter/',
});
Vue.prototype.$image_url = 'https://ourworks.co.in/sigofood/';
//Vue.prototype.$image_url = 'http://localhost/sigofood/';

//********* filters starts ************//

Vue.filter("formatDateTime", function (datetime) {
  if (datetime) {
    //alert(datetime);
    return moment.utc(datetime).format("DD MMM YYYY, hh:mm A");
  }
});

Vue.filter("formatDate", function (date) {
  if (date) {
    return moment(date).format("DD MMM YYYY");
  }
});

Vue.filter("formatTimeOnly", function (datetime) {
  if (datetime) {
    return moment(datetime).format("hh:mm A");
  }
});

Vue.filter('formatTime', function(time) {
  if(time) {
    var datetime = '2022-02-08 ' + time;
    return moment.utc(datetime).format('hh:mm A');
  }
});

Vue.filter('excerpt', function(text, length) {
  if(text) {
    return text.length > length ? text.slice(0, length) + '...' : text;
  }
})

Vue.filter('formatPrice', function(price) {
  if(price) {
    return parseFloat(price).toFixed(2);
  } else {
    return '';
  }
})

//********* filters ends ************//

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
